module.exports = {
	url: '/versante/menu',
	template: require('raw!templates/menu/menu-view.html'),
	controller: MenuController,
	controllerAs: 'menuCtrl',
};

function MenuController($scope, $state, store, $window, contentful, $http, Socialshare) {
	var vm = this;
  $window.scrollTo(0, 0);
	contentful.entries('content_type=diningPage&sys.id=2AN86PHCbkKqwexkOVUx4m').then(function(res) {
		// console.log('menu page contentful data',res);
		$scope.dining = res.data.items[0];
		var seoData = res.data.items[0];
		if (seoData.fields.seoTitle) {
			document.title = seoData.fields.seoTitle;
		}
		if (seoData.fields.seoDescription) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.seoDescription;
				}
			}
		}
	});

		// $('.tri-up a').click(() => {
		// 		console.log(window.pageYOffset);
		// 	$('html, body').animate({
		// 		scrollTop: window.pageYOffset + $(window).height()
		// 	}, 300);
		// 	return false;
		// });
// 	setTimeout(function(){
//   var elem = document.querySelector('.carousel');
//   var flkty = new Flickity(elem, {
//     imagesLoaded: true,
//     draggable: false,
//     percentPostion: false,
//     cellAlign: 'center',
//     wrapAround: true,
//     lazyLoad: true,
//     pageDots: false,
//     autoPlay: true
//   });
// }, 1000);

// document.getElementById("stars").innerHTML = getStars(5);



	vm.trustUrl = "trustUrl";

	trustUrl.$inject = ['$sce'];

	function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}

		$window.sr = ScrollReveal({ reset: false });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#fitness', { distance: 0, duration: 1000, scale: 1.5 }, 500);
}



// WEBPACK FOOTER //
// ./components/templates/menu/menu-controller.js